import {FC, useEffect, useState} from 'react'
import {getActive} from '../../../master-data/deactivation-reason-management/list/core/_requests'
import {DeactivationReasonShort} from '../../../master-data/deactivation-reason-management/list/core/_models'

type Props = {
  value: string
  onChange: (value: string) => void
  disabled?: boolean
}

const DeactivationReasonSelect: FC<Props> = ({value, onChange, disabled}) => {
  const [deactivationReasons, setDeactivationReasons] = useState<DeactivationReasonShort[] | null>(
    []
  )
  const [deactivationReasonsLoading, setDeactivationReasonsLoading] = useState(true)

  useEffect(() => {
    const loadDeactivationReasons = async () => {
      setDeactivationReasonsLoading(true)
      try {
        setDeactivationReasons((await getActive()) ?? [])
      } catch (error) {
        console.error(error)
        setDeactivationReasons(null)
      } finally {
        setDeactivationReasonsLoading(false)
      }
    }
    loadDeactivationReasons()
  }, [])

  return (
    <div className='mb-3'>
      <label
        htmlFor='deactivationReason'
        className='form-label required fs-6 fw-bold text-gray-900 mb-2'
      >
        Deactivation Reason
      </label>
      <select
        name='deactivationReason'
        id='deactivationReason'
        onChange={(e) => onChange(e.target.value)}
        value={value}
        disabled={disabled || deactivationReasonsLoading || !deactivationReasons?.length}
        className='form-select mb-lg-0'
      >
        <option value=''>
          {deactivationReasonsLoading ? 'Loading reasons...' : 'Select Reason'}
        </option>
        {deactivationReasons?.map((deactivationReason) => (
          <option key={deactivationReason.code} value={deactivationReason.name}>
            {deactivationReason.name}
          </option>
        ))}
      </select>
      {!deactivationReasonsLoading && deactivationReasons === null && (
        <div className='text-danger fs-7 mt-2'>
          Unable to load deactivation reasons. Close and try again.
        </div>
      )}
      {!deactivationReasonsLoading && deactivationReasons?.length === 0 && (
        <div className='text-gray-600 fs-7 mt-2'>
          No active deactivation reasons. Add one under Configuration → Reasons.
        </div>
      )}
    </div>
  )
}

export {DeactivationReasonSelect}
